import { WebserviceUrl } from "@tm/data/webserviceUrls"

export function getVehicleGsiServiceUrl() {
    return `${WebserviceUrl.GsiVehicles}`
}
